import { useEffect, useState } from 'react';
import {
  Box,
  Typography,
  RadioGroup,
  Radio,
  TableBody,
  TableRow,
  useTheme,
  TableContainer,
} from '@mui/material';
import Form from 'components/Form';
import {
  StyledTableCellTwo,
  StyledTableCellWithoutLeftTwo,
  StyledTableCellWithoutLeftRightTwo,
} from 'routes/Main/style';
import SectionTitle from '../../components/SectionTitle';

import { IFormValues, IFormWatch, IFormRegister } from 'routes/Main/type';

const radioId11 = [
  'no61',
  'no62',
  'no63',
  'no64',
  'no65',
  'no66',
  'no67',
  'no68',
  'no69',
  'no70',
  'no71',
  'no72',
  'no73',
  'no74',
];

const 영역11 = [
  {
    id: 1,
    ko: '61. 튜브삽입 시 간호',
    info: [
      'NG tube(G-tube), SBtube, Foleycath, 중심정맥관, 흉관, Rectal tube 등의 삽입 당일 준비, 삽입 보조, 정리 및 간호기록이 포함된다.',
      '튜브 교환을 위한 재삽입도 포함된다.',
    ],
    desc: [
      '해당 없음',
      '2점 : NG, SBtube 삽입당일 /Rectal tube 삽입 당일  ',
      '3점 : 유치도뇨관 삽입당일',
      '5점 : 중심정맥관 삽입 당일',
      '7점: 흉관 삽입 당일',
    ],
  },
  {
    id: 2,
    ko: '62. 각종 튜브 유지 관리',
    info: [
      'Penrosedrain, JPdrain, PCD, Gastrostomytube, PTBD, H-vac, NGtube, Rectaltube, Foleycath, 중심정맥관, 흉관 등이 해당된다.',
      'Squeezing, 피부소독,배액양상 관찰기록 등을 포함한다',
    ],
    desc: ['해당 없음     ', '튜브 수 당 1점 :'],
  },
  {
    id: 3,
    ko: '63. 튜브관주(irrigation, instillation)',
    info: [
      '유치도뇨, L-tube, PTBD',
      'tube의 irrigation or instillation을 시행하는 경우이며, 기록이 있어야 한다.',
    ],
    desc: ['해당 없음 ', '1회당 1점 :'],
  },
  {
    id: 4,
    ko: '64. 천자 준비 및 간호',
    info: [
      '심낭, 늑막강, 복강, 요추천자',
      '준비, 천자 중 환자 활력징후 측정, 검사보조, 검체채취, 정리 및 간호기록이 포함된다.',
    ],
    desc: ['해당 없음', '4점'],
  },
  {
    id: 5,
    ko: '65. 단순드레싱',
    info: ['각종 wound 드레싱, 1회 제공 시 마다 가산된다.'],
    desc: ['해당 없음  ', '1회당 1점 : '],
  },
  {
    id: 6,
    ko: '66. 기관절개관 삽입 준비 및 간호',
    info: [
      '중환자실내에서 시행한 경우에만 해당된다.',
      '준비, 삽입시 보조, 정리 등이 포함된다.',
    ],
    desc: ['해당 없음', '6점'],
  },
  {
    id: 7,
    ko: '67. 두개내압 감시 장치 삽입준비 및 간호',
    info: [
      'EVD, Intracranial bolt를 삽입하기 위해 준비, 시행 보조, 정리 및 간호기록 등이 포함된다.',
    ],
    desc: ['해당 없음', '6점'],
  },
  {
    id: 8,
    ko: '68. CRRT 삽입 준비 및 설치',
    info: [
      '중환자실 간호사에 의해 시작 또는 필터를 교체하는 경우가 해당된다. 장비 준비, priming, 기록을 포함한다.',
    ],
    desc: ['해당 없음', '10점'],
  },
  {
    id: 9,
    ko: '69. CRRT 유지 간호',
    info: [
      '장비의 유지를 위해 관찰, 응고예방 활동, 투석액 교환과 간호기록을 포함한다.',
      'I/O는 별도 부여한다.',
    ],
    desc: ['해당 없음', '10점'],
  },
  {
    id: 10,
    ko: '70. 복막투석 시행',
    info: ['중환자실 간호사가 시행하는 경우 해당된다.', 'I/O는 별도 부여한다.'],
    desc: ['해당 없음   ', '1회당 1.5점 :'],
  },
  {
    id: 11,
    ko: '71. 심부혈전 예방간호',
    info: ['IPC나 antiembolic stocking을 적용하는 경우 해당된다.'],
    desc: ['해당 없음', '3점'],
  },
  {
    id: 12,
    ko: '72. 치료적 체온조절 ',
    info: [
      'Hypothermia, Hyperthermia, 냉온찜질',
      '가온 혹은 냉온기기나 찜질팩 등을 이용하여 치료적 체온 조절을 위한 준비, 적용, 관찰 및 기록 등을 시행한 경우에 해당된다.',
    ],
    desc: ['해당 없음', '3점'],
  },
  {
    id: 13,
    ko: '73. 기타 30분 이상 소요되는 처치, 검사',
    info: [
      '복잡 드레싱, IABP 삽입, ECMO 삽입, 기관지내시경 등 30분 이상 직접간호 활동이 이루어지고, 간호기록이 있는 경우에만 해당된다.',
    ],
    desc: ['해당 없음    ', '1회당 6점 :'],
  },
  {
    id: 14,
    ko: '74. 심폐소생술',
    info: [
      '심폐소생술 뿐 아니라 중환자실에서 응급수술시행, CPB 등과 같이 2명 이상의 간호사가 환자 옆에서 keep할 경우에도 해당된다. ',
    ],
    desc: ['해당 없음', '8점: 1시간 이내', '16점: 1시간 이상'],
  },
];

interface Props extends IFormValues, IFormWatch, IFormRegister {
  disabled?: boolean;
  sum7: number;
  setSum7: (sum7: number) => void;

  num62: number;
  setNum62: (num62: number) => void;

  num63: number;
  setNum63: (num63: number) => void;

  num65: number;
  setNum65: (num65: number) => void;

  num70: number;
  setNum70: (num70: number) => void;

  num73: number;
  setNum73: (num73: number) => void;
}
const KPCSCContents5 = (props: Props) => {
  const { palette } = useTheme();

  const {
    disabled,
    setValue,
    getValues,
    setSum7,
    setNum62,
    setNum63,
    setNum65,
    setNum70,
    setNum73,
    register,
  } = props;

  const calculateSumValue11 = () => {
    setSum7(
      radioId11.reduce((acc, cur) => {
        if (
          cur === 'no62' ||
          cur === 'no63' ||
          cur === 'no65' ||
          cur === 'no70' ||
          cur === 'no73'
        ) {
          const value = Number(getValues(cur));
          return value ? acc + value - 1 : acc;
        }
        // 61번
        else if (cur === 'no61') {
          if (Number(getValues(cur)) === 3) {
            const value = Number(getValues(cur)) + 2;
            return value ? acc + value : acc;
          } else if (Number(getValues(cur)) === 4) {
            const value = Number(getValues(cur)) * 2 - 1;
            return value ? acc + value : acc;
          } else if (Number(getValues(cur)) > 0) {
            const value = Number(getValues(cur)) + 1;
            return value ? acc + value : acc;
          }
        }
        // 64번
        else if (cur === 'no64') {
          const value = Number(getValues(cur)) * 4;
          return value ? acc + value : acc;
        }
        // 66, 67번
        else if (cur === 'no66' || cur === 'no67') {
          const value = Number(getValues(cur)) * 6;
          return value ? acc + value : acc;
        }
        // 68, 69번
        else if (cur === 'no68' || cur === 'no69') {
          const value = Number(getValues(cur)) * 10;
          return value ? acc + value : acc;
        }
        // 71, 72번
        else if (cur === 'no71' || cur === 'no72') {
          const value = Number(getValues(cur)) * 3;
          return value ? acc + value : acc;
        }
        // 74번
        else if (cur === 'no74') {
          const value = Number(getValues(cur)) * 8;
          return value ? acc + value : acc;
        }
        const value = Number(getValues(cur));
        return value ? acc + value : acc;
      }, 0)
    );
  };

  const handleChange11 = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    calculateSumValue11();
  };

  const [disable62, setDisable62] = useState(false);
  const [disable63, setDisable63] = useState(false);
  const [disable65, setDisable65] = useState(false);
  const [disable70, setDisable70] = useState(false);
  const [disable73, setDisable73] = useState(false);

  const handleChange_62_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no62_1', 0);
    setNum62(0);
    setDisable62(true);
    calculateSumValue11();
  };

  const handleChange_62_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no62_1', 1);
    setNum62(1);
    setDisable62(false);
    calculateSumValue11();
  };

  const handleChange_63_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no63_1', 0);
    setNum63(0);
    setDisable63(true);
    calculateSumValue11();
  };

  const handleChange_63_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no63_1', 1);
    setNum63(1);
    setDisable63(false);
    calculateSumValue11();
  };

  const handleChange_65_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no65_1', 0);
    setNum65(0);
    setDisable65(true);
    calculateSumValue11();
  };

  const handleChange_65_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no65_1', 1);
    setNum65(1);
    setDisable65(false);
    calculateSumValue11();
  };

  const handleChange_70_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no70_1', 0);
    setNum70(0);
    setDisable70(true);
    calculateSumValue11();
  };

  const handleChange_70_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no70_1', 1);
    setNum70(1.5);
    setDisable70(false);
    calculateSumValue11();
  };

  const handleChange_73_none = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no73_1', 0);
    setNum73(0);
    setDisable73(true);
    calculateSumValue11();
  };

  const handleChange_73_One = (
    e: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => {
    setValue(e.target.name, e.target.value);
    setValue('no73_1', 1);
    setNum73(6);
    setDisable73(false);
    calculateSumValue11();
  };

  useEffect(() => {
    calculateSumValue11();
  }, []);

  return (
    <>
      <SectionTitle title="영역 : 처치 및 시술" />
      <Box sx={{ width: '98%', margin: '20px' }}>
        <TableContainer sx={{ marginTop: '20px', marginBottom: '-20px' }}>
          <TableBody>
            {영역11.map(
              (
                content: {
                  id: number;
                  ko: string;
                  info: string[];
                  desc: string[];
                },
                i
              ) => (
                <TableRow>
                  <StyledTableCellTwo
                    sx={{
                      padding: '16px',
                      width: '300px',
                      whiteSpace: 'pre-wrap',
                      verticalAlign: 'top',
                      borderBottom: 영역11.length - 1 === i ? 'none' : '',
                    }}
                  >
                    {content.ko}
                  </StyledTableCellTwo>
                  <StyledTableCellWithoutLeftTwo
                    sx={{
                      borderBottom: 영역11.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <RadioGroup
                      sx={{
                        paddingTop: content.info.length > 1 ? '55px' : '28px',
                      }}
                      name={radioId11[content.id - 1]}
                      defaultValue={Number(
                        getValues(radioId11[content.id - 1])
                      )}
                    >
                      {content.desc.map((point, i) => {
                        if (point === '해당 없음     ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no62'}
                                  value={i}
                                  onChange={handleChange_62_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '튜브 수 당 1점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no62'}
                                  value={i}
                                  onChange={handleChange_62_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음 ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no63'}
                                  value={i}
                                  onChange={handleChange_63_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 1점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no63'}
                                  value={i}
                                  onChange={handleChange_63_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음  ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no65'}
                                  value={i}
                                  onChange={handleChange_65_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 1점 : ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no65'}
                                  value={i}
                                  onChange={handleChange_65_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음   ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no70'}
                                  value={i}
                                  onChange={handleChange_70_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 1.5점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no70'}
                                  value={i}
                                  onChange={handleChange_70_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '해당 없음    ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no73'}
                                  value={i}
                                  onChange={handleChange_73_none}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (point === '1회당 6점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={'no73'}
                                  value={i}
                                  onChange={handleChange_73_One}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '43px',
                                textAlign: 'center',
                              }}
                            >
                              <Box>
                                <Radio
                                  disabled={disabled}
                                  name={radioId11[content.id - 1]}
                                  value={i}
                                  onChange={handleChange11}
                                />
                              </Box>
                            </TableRow>
                          );
                      })}
                    </RadioGroup>
                  </StyledTableCellWithoutLeftTwo>
                  <StyledTableCellWithoutLeftRightTwo
                    sx={{
                      borderBottom: 영역11.length - 1 === i ? 'none' : '',
                    }}
                  >
                    <Box>
                      {content.info.includes('') ? (
                        <TableRow
                          sx={{
                            height: '16px',
                          }}
                        >
                          <Box sx={{ minWidth: '500px' }}> </Box>
                        </TableRow>
                      ) : content.info.length > 1 ? (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '23px',
                                height: '4px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      ) : (
                        content.info.map((item, i) => {
                          return (
                            <TableRow
                              sx={{
                                height: '8.5px',
                              }}
                            >
                              <Box
                                sx={{ minWidth: '65vw', marginLeft: '-28px' }}
                              >
                                ・ {item}
                              </Box>
                            </TableRow>
                          );
                        })
                      )}
                      {content.desc.map((v, i) => {
                        if (v === '튜브 수 당 1점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable62 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '10px' }}
                                  InputProps={{
                                    ...Form.adornment('', '튜브'),
                                  }}
                                  {...register('no62_1', {
                                    onChange: e => {
                                      setValue(
                                        'no62_1',
                                        Number(e.target.value)
                                      );
                                      setNum62(Number(getValues('no62_1')));
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1회당 1점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable63 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '32px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no63_1', {
                                    onChange: e => {
                                      setValue(
                                        'no63_1',
                                        Number(e.target.value)
                                      );
                                      setNum63(Number(getValues('no63_1')));
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1회당 1점 : ') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable65 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '30px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no65_1', {
                                    onChange: e => {
                                      setValue(
                                        'no65_1',
                                        Number(e.target.value)
                                      );
                                      setNum65(Number(getValues('no65_1')));
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1회당 1.5점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable70 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '22px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no70_1', {
                                    onChange: e => {
                                      setValue(
                                        'no70_1',
                                        Number(e.target.value)
                                      );
                                      setNum70(
                                        Number(getValues('no70_1')) * 1.5
                                      );
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        } else if (v === '1회당 6점 :') {
                          return (
                            <TableRow
                              sx={{
                                lineHeight: '42px',
                              }}
                            >
                              <Box sx={{ minWidth: '500px' }}>
                                {v}
                                <Form.MuiTextField
                                  required={false}
                                  type="number"
                                  textAlign="right"
                                  disabled={disable73 ? true : disabled}
                                  sx={{ width: '200px', marginLeft: '29px' }}
                                  InputProps={{
                                    ...Form.adornment('', '회'),
                                  }}
                                  {...register('no73_1', {
                                    onChange: e => {
                                      setValue(
                                        'no73_1',
                                        Number(e.target.value)
                                      );
                                      setNum73(Number(getValues('no73_1')) * 6);
                                    },
                                  })}
                                />
                              </Box>
                            </TableRow>
                          );
                        }
                        return (
                          <TableRow
                            sx={{
                              lineHeight: '42px',
                            }}
                          >
                            <Box sx={{ minWidth: '500px' }}>{v}</Box>
                          </TableRow>
                        );
                      })}
                    </Box>
                  </StyledTableCellWithoutLeftRightTwo>
                </TableRow>
              )
            )}
          </TableBody>
        </TableContainer>
      </Box>
    </>
  );
};

export default KPCSCContents5;
